import React from 'react';
import './styles.css';

export default function ScrollTop() {
    document.addEventListener('scroll', () => {
        const scrollTopButton = document.getElementById('scrollTopBtn');
        const scrollOffsetTop = 100;
        if (document.body.scrollTop > scrollOffsetTop || document.documentElement.scrollTop > scrollOffsetTop) {
            scrollTopButton && scrollTopButton.classList && scrollTopButton.classList.add('show-btn-scroll-top');
        } else {
            scrollTopButton && scrollTopButton.classList && scrollTopButton.classList.remove('show-btn-scroll-top');
        }
    });

    if (window.location.pathname === '/auth/login') {
        return null;
    }

    const scrollToTop = () => {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
        })
    };

    return (
        <button
            id="scrollTopBtn"
            className="btn-scroll-top btn btn-primary"
            onClick={scrollToTop}
        >
            <i className="fa fa-chevron-up"></i>
        </button>
    )
}